import { Body, Controller, Post, Req, UseInterceptors } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import {
  AllRolesResponseModel,
  CommonResponseModel,
} from "@project-management-system/shared-models";
import { ApplicationExceptionHandler } from "packages/libs/backend-utils/src/";
import { RoleService } from "./role-service";
import { RoleDto } from "./role-dto";

@ApiTags("/roles")
@Controller("roles")
export class RoleController {
  constructor(
    private readonly roleService: RoleService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler
  ) { }

  @ApiBody({ type: RoleDto })
  @Post("/createRole")
  async createRole(
    @Body() dto: any,
    isUpdate: boolean = false
  ): Promise<AllRolesResponseModel> {
    try {
      return await this.roleService.createRole(dto, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        AllRolesResponseModel,
        error
      );
    }
  }

  @Post("/updateRole")
  @ApiBody({ type: RoleDto })
  async updateRole(@Body() req: any): Promise<CommonResponseModel> {
    try {
      return await this.roleService.updateRole(req);
    } catch (error) {
      // return errorHandler(ProcurmentGroupResponseModel,error);
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  @Post("/getAllRoles")
  async getAllRoles(): Promise<CommonResponseModel> {
    try {
      return await this.roleService.getAllRoles();
    } catch (err) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        err
      );
    }
  }

  @Post('/getActiveAllRoles')
    async getActiveAllRoles(): Promise<CommonResponseModel> {
        try {
            return await this.roleService.getActiveAllRoles();
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

  @Post("/activateOrDeactivateRole")
  @ApiBody({ type: RoleDto })
  async activateOrDeactivateRole(
    @Body() dto: any,
    isUpdate: boolean = false
  ): Promise<CommonResponseModel> {
    try {
      return await this.roleService.activateOrDeactivateRole(dto);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }
}
